import EnemyData from "./EnemyDataInterface";
import EnemyType from "../../enums/EnemyType";

const GREEN_STAGES_SWARMS: {
    [key in EnemyType]?: EnemyData[];
  } = {
    //replaces HAMSTER_SWARM
    [EnemyType.CHICKEN_SWARM]: [
      {
        level: 1,
        maxHp: 0.1,
        speed: 800,
        power: 4,
        knockback: 0,
        deathKB: 0,
        killedAmount: 0,
        xp: 1.5,
        scale: 1.5,
        spriteName: "chicken",
        animationKey: "chicken_run",
        skills: ["FixedDirection"],
      },
    ],
    //replaces SCORPION_SWARM
    [EnemyType.SPIDER_SWARM]: [
      {
        level: 1,
        maxHp: 1,
        speed: 1000,
        power: 8,
        knockback: 0,
        deathKB: 0,
        killedAmount: 0,
        xp: 1.5,
        scale: 1.2,
        spriteName: "spider",
        animationKey: "spider_run",
        skills: ["FixedDirection"],
      },
    ],
    //replaces VULTURE_SWARM
    [EnemyType.BEE_SWARM]: [
      {
        level: 1,
        maxHp: 4,
        speed: 1000,
        power: 14,
        knockback: 0,
        deathKB: 0,
        killedAmount: 0,
        xp: 1.5,
        scale: 1,
        spriteName: "bee",
        animationKey: "bee_run",
        skills: ["FixedDirection"],
      },
    ],
  };
  export default GREEN_STAGES_SWARMS;